// extracted by mini-css-extract-plugin
export var errorIcon = "_jx-1";
export var nameLogo = "_jx-0";